import { useEffect, useState } from 'react';
import { FormControl, FormLabel, VStack } from '@chakra-ui/react';

import StrongModal from '../common/StrongModal';
import StrongInput from '../common/StrongInput';
import StrongImageDragDrop from '../common/StrongImageDragDrop';

interface EditCategoryModalProps {
  selectedCategory?: Category;
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (title: string, thumbnail: File | null) => void;
}

const EditCategoryModal = ({
  selectedCategory,
  isOpen,
  onClose,
  onSubmit,
}: EditCategoryModalProps) => {
  const [title, setTitle] = useState<string>('');
  const [thumbnail, setThumbnail] = useState<File | null>(null);

  useEffect(() => {
    setTitle(selectedCategory?.title || '');
    setThumbnail(null);
  }, [selectedCategory]);

  return (
    <StrongModal
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={() => onSubmit(title, thumbnail)}
      title={selectedCategory ? 'Edit Category' : 'Create Category'}
      isSubmitDisabled={!title}
      body={
        <VStack spacing={4} align='stretch'>
          <FormControl>
            <FormLabel color='gray.600'>Title</FormLabel>
            <StrongInput
              placeholder='Enter title'
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </FormControl>

          <FormControl>
            <FormLabel color='gray.600'>Thumbnail</FormLabel>
            <StrongImageDragDrop
              onFileSelect={setThumbnail}
              defaultImageUrl={selectedCategory?.thumbnail}
            />
          </FormControl>
        </VStack>
      }
    />
  );
};

export default EditCategoryModal;
